import { useState } from 'react';
import { Input, Radio } from 'antd';
import { ModalComponent } from '../baseComponents';

export const SavedSearchEncounterModal = ({
  isEncounterVisible,
  handleCloseView,
  selectedPractitioner,
  renameTitleEncounter,
  setRenameTitleEncounter,
  duplicateError,
  setDuplicateError,
  handleSaveDuplicate,
  selectedTab,
  searchFilters,
  isDefaultView,
  setDefaultPreferenceValue,
  selectedFilter,
}) => {
  const [showError, setShowError] = useState(false);

  const onChangeHandler = (event) => {
    const value = event.target.value;
    setRenameTitleEncounter(value);
    if (value === '') {
      setShowError(true);
      setDuplicateError(false);
    } else {
      setShowError(false);
    }
  };

  const isMobileView = window.innerWidth <= 1260;
  const onChange = (e) => {
    setDefaultPreferenceValue(e.target.value);
  };
  return (
    <>
      <ModalComponent
        centered={true}
        open={isEncounterVisible}
        handleSubmit={
          renameTitleEncounter.trim() !== ''
            ? handleSaveDuplicate
            : () => setShowError(true)
        }
        handleCancel={handleCloseView}
        className={'notificationHistory-page-table'}
        submitButtonText="Save"
        cancelButtonText="Cancel"
        closable={true}
        additionalBody={
          <>
            <div className="mb-5 font-medium text-xl">Save view</div>
            <div className=" space-y-2 ">
              <div className="font-medium">
                Practitioner Name:{' '}
                <span className="text-gray-500">{selectedPractitioner}</span>
              </div>
              <div className="font-medium">
                Status:{' '}
                <span className="text-gray-500">
                  {searchFilters?.status
                    ? searchFilters.status.charAt(0).toUpperCase() +
                      searchFilters.status.slice(1)
                    : 'All'}
                </span>
              </div>
              <div className="font-medium ">
                Date: {'  '}
                <span className="text-gray-500">
                  {/* {selectedDate === "Custom…🗓️" ? "N/A" : selectedDate} */}
                  {isMobileView
                    ? selectedTab && selectedTab
                    : selectedFilter === 'Yesterday' ||
                        selectedFilter === 'Past 7 days' ||
                        selectedFilter === 'Today' ||
                        selectedFilter === 'All time'
                      ? selectedFilter
                      : 'N/A'}
                </span>
              </div>
              <div className="font-medium ">
                Set as Default: {'  '}
                <span className="text-gray-500 ml-1">
                  <Radio.Group
                    onChange={onChange}
                    value={isDefaultView}
                    options={[
                      {
                        value: true,
                        label: 'Yes',
                      },
                      {
                        value: false,
                        label: 'No',
                      },
                    ]}
                  />
                </span>
              </div>
            </div>

            <div className="mt-3 flex items-center bg-white border border-[#e5e8eb] rounded-xl">
              <Input
                bordered={false}
                placeholder="Enter a name for this view"
                className="h-14"
                value={renameTitleEncounter}
                onChange={onChangeHandler}
              />
            </div>
            {showError && (
              <div style={{ color: 'red' }}>
                Please enter a name for this view.
              </div>
            )}
            {duplicateError && (
              <div style={{ color: 'red' }}>
                This name already exists. Please enter a different name.
              </div>
            )}
          </>
        }
      />
    </>
  );
};
